var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasBookmarks
    ? _c("expandable-panel", {
        staticClass: "notes-expansion-panel-wrapper",
        attrs: {
          expand: _vm.expand,
          id: `notes-expansion-panel-wrapper-${_vm.sectionId}`,
          outlined: "",
        },
        scopedSlots: _vm._u(
          [
            {
              key: "title",
              fn: function () {
                return [
                  _c("div", { staticStyle: { display: "inline" } }, [
                    _c(
                      "span",
                      { staticClass: "text--secondary font-weight-bold" },
                      [
                        _vm._v(
                          "\n      NOTES (" +
                            _vm._s(_vm.bookmarksCount) +
                            ")\n    "
                        ),
                      ]
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "content",
              fn: function () {
                return _vm._l(_vm.localBookmarks, function (item) {
                  return _c(
                    "v-card",
                    {
                      key: item.id,
                      attrs: { id: "bookmark-list-item-" + item.id, flat: "" },
                    },
                    [
                      _c(
                        "v-card-text",
                        { staticClass: "pa-0 notes-bookmarks-section" },
                        [
                          _c("note-list-item", {
                            attrs: {
                              type: _vm.bookmarkType(item),
                              data: item,
                              tags: _vm.tags,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                })
              },
              proxy: true,
            },
          ],
          null,
          false,
          3539272858
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }